import Panes from "@views/Panes";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import Forgotten from "./auth/Forgotten";
import Login from "./auth/Login";
import Reset from "./auth/Reset";
import Incompatible from "@views/Incompatible";
import { detect } from "detect-browser";

const App = () => {
  const [loading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch("/config.json")
      .then((response) => response.json())
      .then((response) => {
        sessionStorage.setItem("base_url", response.base_url);
        sessionStorage.setItem("auth_api_url", response.auth_api_url);
        sessionStorage.setItem("comp_api_url", response.comp_api_url);
        sessionStorage.setItem("escalated_review_url", response.escalated_review_url);
        setTimeout(() => setIsLoading(false), 500);
      });
  }, [loading]);

  const browser = detect();
  if (browser.name === "ie") {
    return <Incompatible />;
  }

  if (loading) {
    return <Loader active />;
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/forgotten" component={Forgotten} />
        <Route path="/reset" component={Reset} />
        <Route path="/dashboard" component={Panes} />
        <Route exact path="/" component={Login} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
